import { Game } from "../types/models";

/**
 * Picks the games that make up each team's next (or most recent) `perTeam`
 * games, so a league summary shows every team rather than only the teams
 * playing soonest.
 *
 * Games must already be sorted in the order they should be consumed —
 * chronologically for upcoming games, reverse-chronologically for results.
 * A game is included when it falls within either team's first `perTeam`
 * games of that ordering, and the returned games keep the input order.
 *
 * For a 4-team league playing two games a week, `perTeam` of 2 yields the
 * four games of the next two weeks.
 */
export function selectGamesPerTeam(games: Game[], perTeam: number): Game[] {
  if (perTeam <= 0) return [];

  const gamesSeenByTeam = new Map<number, number>();

  return games.filter((game) => {
    const teamIds = [game.home_team_id, game.visitor_team_id];
    const isWithinLimit = teamIds.some(
      (teamId) => (gamesSeenByTeam.get(teamId) ?? 0) < perTeam,
    );

    teamIds.forEach((teamId) =>
      gamesSeenByTeam.set(teamId, (gamesSeenByTeam.get(teamId) ?? 0) + 1),
    );

    return isWithinLimit;
  });
}
